// navConfig.js
import {
  RiAdminLine,
  RiDashboardFill,
  RiRoadMapFill,
  RiExchangeBoxFill,
  RiCashFill,
  RiCalendar2Fill,
  RiPriceTag2Fill,
  RiSettings2Fill,
  RiBook2Fill,
  RiSearchLine,
} from "react-icons/ri";
import { ViewMode } from "../../../store";

export const navigationGroups = (
  isUserAdmin: boolean,
  isCollapsed: boolean,
  viewMode: ViewMode
) => {
  const groups = [
    {
      label: "Insights",
      items: [
        // In simple mode, we will show an additional "Dashboard Simple" entry via filtering below
        {
          path: "/app/dashboard",
          icon: RiDashboardFill,
          label: "Dashboard",
        },
        {
          path: "/app/calendar",
          icon: RiCalendar2Fill,
          label: "Calendar",
        },
      ],
    },
    {
      label: "Data",
      items: [
        {
          path: "/app/positions",
          icon: RiRoadMapFill,
          label: "Positions",
        },
        {
          path: "/app/trades",
          icon: RiExchangeBoxFill,
          label: "Trades",
        },
        {
          path: "/app/cashflows",
          icon: RiCashFill,
          label: "Cashflows",
        },
        {
          path: "/app/prices",
          icon: RiPriceTag2Fill,
          label: "Prices",
        },
        {
          path: "/app/scanner",
          icon: RiSearchLine,
          label: "Options Scanner",
          badge: "Alpha",
        },
      ],
    },
    {
      label: "Configuration",
      items: [
        {
          path: "/app/settings",
          icon: RiSettings2Fill,
          label: "Settings",
        },
        ...(isUserAdmin
          ? [
              {
                path: "/app/admin",
                icon: RiAdminLine,
                label: "Admin",
              },
            ]
          : []),
      ],
    },
    {
      label: "Support",
      items: [
        {
          external: true,
          url: "https://wealthbee.io/knowledgebase",
          icon: RiBook2Fill,
          label: "User Guide",
          isExternal: true,
        },
      ],
    },
  ];

  if (viewMode === "advanced") {
    return groups;
  }

  // Simple view: keep Dashboard, Positions, Trades, Settings, User Guide
  const allowedPaths = new Set([
    "/app/dashboard",
    "/app/dashboard-simple",
    // "/app/positions",
    "/app/trades",
    "/app/settings",
    "/app/scanner",
  ]);
  const filtered = groups
    .map((group) => {
      let items = group.items.filter((item: any) => {
        if (item.external) {
          return item.label === "User Guide";
        }
        return item.path && allowedPaths.has(item.path);
      });

     

      return { ...group, items };
    })
    .filter((group) => group.items.length > 0);

  return filtered;
};
